// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"keywords_suggest-module__wrapper--hHtu2","title":"keywords_suggest-module__title--6n35Y"};